<template>
  <div class="wrapper-prepayment">
    <section
      ref="section-topbar"
      class="section-topbar"
    >
      <div class="back">
        <button @click="handleClickBack">
          <i class="fas fa-angle-left"/>
        </button>
      </div>
      <div class="order-total">
        {{ $t('apps.pos.message.currentsale', { number: ordersCount }) }}
      </div>
      <div class="fake">
        &nbsp;
      </div>
    </section>

    <section
      :style="[{ height: `${sectionOrderHeight}px` }]"
      class="section-order">
      <orderlist-view
        class="order-list"
        disabled="false"
        @onDeleteOrder="handleOnDeleteOrder"
      />
    </section>

    <section
      ref="section-checkout"
      class="section-checkout"
    >
      <optionsbutton-view
        class="btn-options"
        @onClearOrder="handleClearOrder"/>
      <div>
        <totalprice-view
          class="total-price"
          disabled="true"
          style="border-top: solid 1px #F2F2F2;"
        />
      </div>
      <div class="container-btn">
        <TotalPriceButton
          disabled="false"
          class="btn-submit-order"
        />
      </div>
    </section>
  </div>
</template>

<script>
import orderlistView from '@/components/apps/pos/sale/mobile/common/OrderList.vue'
import totalpriceView from '@/components/apps/pos/sale/mobile/common/TotalPrice.vue'
import TotalPriceButton from '../common/TotalPriceButton.vue'
import { mapActions, mapGetters } from 'vuex'
import optionsbuttonView from '../../main/common/OptionsButton.vue'

export default {
  components: {
    orderlistView,
    totalpriceView,
    TotalPriceButton,
    optionsbuttonView,
  },

  data() {
    return {
      sectionOrderHeight: 0,
    }
  },

  computed: {
    ...mapGetters({
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // current table number selected
      getPosOrdersById: 'getPosOrdersById', // get orders from table number
    }),
    ordersByTableNumber() {
      return this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
    },
    ordersCount() {
      return this.ordersByTableNumber.reduce((acc, cur) => {
        return cur.quantity + acc
      }, 0)
    },
  },

  mounted() {
    this.setUI()

    window.addEventListener('resize', this.handleWindowResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize, false)
  },

  methods: {
    ...mapActions([
      'setPosSection',
    ]),
    handleWindowResize() {
      this.setUI()
    },
    setUI() {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        const sectionTopbar = this.$refs['section-topbar']
        const sectionCheckout = this.$refs['section-checkout']
        this.sectionOrderHeight = windowHeight - $(sectionTopbar).outerHeight() - $(sectionCheckout).outerHeight()
      })
    },
    handleClickBack() {
      this.setPosSection('choose-product')
    },
    handleOnDeleteOrder() {
      this.setUI()
      if (this.ordersCount === 0) {
        this.handleClickBack()
      }
    },
    handleClearOrder() {
      this.setUI()
      this.handleClickBack()
    },
  },
}
</script>

<style scoped>
.wrapper-prepayment {
  background: #fff;
}

.section-topbar {
  height: var(--header-pos-height);
  display: flex;
  align-items: center;
  /* border-bottom: solid 2px #ebe8e8; */
  background: var(--bg-color);
}

.section-topbar .back {
  width: var(--header-pos-height);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

.section-topbar .order-total {
  flex: 1;
  display: flex;
  justify-content: center;
  color: #fff;
}

.section-topbar .fake {
  width: var(--header-pos-height);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.section-topbar button {
  background: none;
  border: none;
  outline: none;
  color: #fff;
  width: 100%;
  height: 100%;
}

.section-order {
  overflow-y: auto;
}

.section-checkout {
  /* background: #F6F3F2; */
  /* border-top: solid 2px #ebe8e8; */
}

.section-checkout .container-btn {
  display: flex;
  gap: 12px;
  padding: 8px 12px 12px 12px;
}

.section-checkout .container-btn .btn-submit-order {
  flex: 1;
  font-size: 20px;
}

.btn-options /deep/ button.action-btn.btn-custom {
  padding: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/include/PrePayment.vue